import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: 'AIzaSyDX--yrDe_zLJo1U1iowcK4FAx81yqNI3Q',
  authDomain: 'prema-2798d.firebaseapp.com',
  projectId: 'prema-2798d',
  storageBucket: 'prema-2798d.firebasestorage.app',
  messagingSenderId: '840916119376',
  appId: '1:840916119376:web:d4cf7400411961f3ee0655',
  measurementId: 'G-SYXN4DPJ5H',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and Firestore
const auth = getAuth(app);
const db = getFirestore(app);

export { auth, db };
